// extracted by mini-css-extract-plugin
module.exports = {"bold":"P-module__bold___V7X4C","center":"P-module__center___1re6x","xl":"P-module__xl___2KVsX","l":"P-module__l___2sZau","m":"P-module__m___gfIZF","s":"P-module__s___1bjTb"};